import Vue from 'vue';
// Session-specific store module
export class SessionStore {
    state = Vue.observable({
        sessions: [],
        currentSession: null,
        loading: false,
        error: null,
        lastFetched: null
    });
    // Getters
    get sessions() {
        return this.state.sessions;
    }
    get currentSession() {
        return this.state.currentSession;
    }
    get loading() {
        return this.state.loading;
    }
    get error() {
        return this.state.error;
    }
    get hasCurrentSession() {
        return this.state.currentSession !== null;
    }
    get currentSessionId() {
        return this.state.currentSession?.id || null;
    }
    // Actions
    setLoading(loading) {
        this.state.loading = loading;
    }
    setError(error) {
        this.state.error = error;
    }
    setSessions(sessions) {
        this.state.sessions = sessions;
        this.state.lastFetched = new Date();
    }
    setCurrentSession(session) {
        this.state.currentSession = session;
        this.state.error = null;
    }
    updateCurrentSession(updates) {
        if (this.state.currentSession) {
            Object.assign(this.state.currentSession, updates);
        }
    }
    addSession(session) {
        this.state.sessions.push(session);
    }
    removeSession(sessionId) {
        const index = this.state.sessions.findIndex(s => s.id === sessionId);
        if (index > -1) {
            this.state.sessions.splice(index, 1);
        }
    }
    clearCurrentSession() {
        this.state.currentSession = null;
        this.state.error = null;
    }
    clearAll() {
        this.state.sessions = [];
        this.state.currentSession = null;
        this.state.loading = false;
        this.state.error = null;
        this.state.lastFetched = null;
    }
}
// Export singleton instance
export const sessionStore = new SessionStore();
